






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IOffer } from '../../data/model';
import { QBtn } from 'quasar';
import { TranslatedComponent } from '../translatedComponent';

@Component({ components: { QBtn } })
export default class Offer extends TranslatedComponent {
    @Prop()
    protected offer!: IOffer;

    @Prop({default: false})
    protected overviewMode!: boolean;

    private period = this.offer.defaultPeriod || 6;

    get price() {
        return this.offer.pricing[this.period];
    }
}
